import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { reportDWH } from '../../EnergyReplaceBlockSlice';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import successIcon from './images/success-icon.svg';

const SuccessPage = (props) => {
const selectedPackageTitle = props.selectedPackage?.title.replace(/<[^>]+>/g, '');

    useEffect(() => {

    }, []);

    return (
        <div className='success-page'>

            <div className='success-icon' style={{backgroundImage:successIcon.bg()}}></div>
            <div className='page-title'> התוכנית עודכנה בהצלחה </div>
            <div className='package-name'> תכנית {selectedPackageTitle} </div>
            <div className='page-sub-title'> התכנית תתעדכן במנוי שלך <br/> בתחילת החודש הבא </div>

            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text='סיום'
                    onclick={handleOnContinue}
                    formid='success-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}
                />
            </div>

        </div>
    );

    function handleOnContinue() {
        buildUrlAndOpenSameWindow(Config.selfCareElectricityLink);
    }

};

const mapStateToProps = (state) => {
    return {
        selectedPackage: state.energyReplaceBlock.selectedPackage,
    };
};

const mapDispatchToProps = {
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
